// AMBIENTE SVILUPPO
// url per autenticazione cas
// export const casURL = 'https://phabtest.divsi.unimi.it:6443/login?service=';
// export const baseURL = 'http://batcave.divsi.unimi.it:3000/registridoce.html';
// export const logoutURL = 'https://phabtest.divsi.unimi.it:6443/logout';

// url webservices
// export const registriWS = 'http://batcave.divsi.unimi.it:9000';
// export const didatticaWS = 'https://www.unimi.it/ws/offertadidattica';

// AMBIENTE TEST (su phabtest.divsi.unimi.it)
// url per autenticazione cas
// export const casURL = 'https://sso.staging.unimi.it:6443/login?service=';
// export const baseURL = 'https://phabtest.divsi.unimi.it/registri/docenti';
// export const logoutURL = 'https://sso.staging.unimi.it:6443/logout';
// ADESSO SPACCO GIT(FORSE...)
// url webservices
// export const registriWS = 'https://phabtest.divsi.unimi.it/wsregistri/';
// export const didatticaWS = 'https://www.unimi.it/ws/didattica';

// AMBIENTE PRODUZIONE
// url per autenticazione cas(ambiente di prod)
export const casURL = 'https://cas.unimi.it/login?service=';
export const baseURL = 'https://apps.unimi.it/web/registri/docenti';
export const logoutURL = 'https://cas.unimi.it/logout';

// url webservices
export const registriWS = 'https://apps.unimi.it/ws/registridocenti';
export const didatticaWS = 'https://apps.unimi.it/ws/offertadidattica';

// GOOGLE ANALYTICS
export const analytics = {
  enabled: true,
  trackingId: 'UA-98136694-1',
  trackUsers: true,
};
